/* eslint-disable max-len */
import React from 'react';
import { Row, Col } from 'antd';

// Edit freely — these are your "at a glance" facts. Icons live in /static
// (available: location, graduation, web, meeting, coffee, motorcycle, contact).
const facts = [
  { icon: 'location.png', sub: 'Based in', title: 'Islamabad, Pakistan' },
  { icon: 'graduation.png', sub: 'Pursuing MS in', title: 'Computer Engineering' },
  { icon: 'web.png', sub: 'Focused on', title: 'Robotics & Sim2Real' },
  { icon: 'meeting.png', sub: 'Co-founder of', title: 'AyroX Labs' },
  { icon: 'coffee.png', sub: 'Powered by', title: 'Coffee & Code' },
  { icon: 'motorcycle.png', sub: 'Off the clock', title: 'Football & Reading' },
];

const cardStyle = {
  border: '2px solid #F5F8F9',
  borderRadius: '15px',
  padding: '30px 16px',
  textAlign: 'center',
  height: '100%',
};
const subStyle = { color: '#8a94a6', margin: '16px 0 4px', fontSize: '0.95rem' };
const titleStyle = {
  color: '#44566C', fontWeight: 600, fontSize: '1.05rem', margin: 0,
};

const QuickFacts = () => (
  <Row gutter={[20, 20]}>
    {facts.map((f) => (
      <Col xs={24} sm={12} md={12} lg={8} key={f.title}>
        <div style={cardStyle}>
          <img src={`../${f.icon}`} alt="" height={64} width={64} />
          <p style={subStyle}>{f.sub}</p>
          <p style={titleStyle}>{f.title}</p>
        </div>
      </Col>
    ))}
  </Row>
);

export default QuickFacts;
